<template>
  <div>
    <VButton
      text="Печать ТН"
      size="sm"
      icon="print"
      @click.native="openModal"
    />

    <ModalPrint
      v-if="isModal"
      class="modal--print-waybill"
      :init-print-type="options[0].value"
      :print-options="options"
      :disabled-btn-submit="isDisabledBtnSubmit"
      title="Печать: "
      :subtitle="options[0].title"
      @request="onSubmit"
      @reject="closeModalPrint"
    >
      <VCheckbox
        v-model="isCommentEnabled"
        label="Вставить комментарий к отгрузке"
      />

      <div v-if="isCommentEnabled" class="d-flex ai-fe flex-col w-100">
        <VInput
          label="Комментарий к отгрузке"
          type="textarea"
          name="comment"
          :value="waybill.comment"
        />
      </div>

      <template v-if="isCommentEnabled" v-slot:customBtn>
        <VButton
          text="Подтвердить"
          size="l"
          @click.native="onClickBtnOk"
        />
      </template>
    </ModalPrint>

    <ModalFilesPreview
      v-if="isFilePreview"
      :files="files"
      :init-active-file-idx="activeFileIdx"
      @close="isFilePreview = false"
    />
  </div>
</template>

<script>
import VButton from '@/components/simple/button/VButton.vue'
import ModalPrint from '@/components/ui/Modal/ModalPrint.vue'
import { mixinModal } from '@/mixins/modal/mixinModal'
import { waybillModel } from '@/entities/waybill'
import { PRINT_OPTIONS } from '../model/const'
import { showAlertError } from '@/utils/store/alert'
import { ReportApi } from '@/api/report/ReportApi'
import ModalFilesPreview from '@/components/files/ModalFilesPreview'
import VCheckbox from '@/components/Form/VCheckbox.vue'
import VInput from '@/components/Form/Vinput/VInput.vue'
import mediaService from '@/services/media.service'

export default {
  components: {
    VInput,
    VCheckbox,
    ModalPrint,
    VButton,
    ModalFilesPreview
  },
  mixins: [mixinModal],
  props: {
    waybill: {
      type: waybillModel.Waybill,
      required: true
    }
  },

  data: () => ({
    files: [],
    activeFileIdx: 0,
    isFilePreview: false,
    isCommentEnabled: false,
    isPressedBtnOk: false
  }),

  computed: {
    options: () => PRINT_OPTIONS,

    // Дизейблим кнопку, если выбрали вставку комментария, до нажатия кнопки ОК
    isDisabledBtnSubmit () {
      return this.isCommentEnabled && !this.isPressedBtnOk
    }
  },

  mounted () {
    // this.createFiles()
  },

  methods: {
    async createFiles (data) {
      try {
        this.$store.commit('START_IS_SENDING_REQUEST_MODAL')
        this.files = []
        const [pdfResponse, docxResponse] = await Promise.all([
          ReportApi.getBy('waybills', {
            waybill_ids: [this.waybill.id],
            comment: data?.comment ?? null
          }, 'pdf'),
          ReportApi.getBy('waybills', {
            waybill_ids: [this.waybill.id],
            comment: data?.comment ?? null
          }, 'docx')
        ])
        this.files.push({
          pdf: new File(
            [pdfResponse.data],
            mediaService.getFileNameFromHeaders(pdfResponse.headers, 'report.pdf'),
            { type: pdfResponse.data.type }
          ),
          docx: new File(
            [docxResponse.data],
            mediaService.getFileNameFromHeaders(docxResponse.headers, 'report.docx'),
            { type: docxResponse.data.type }
          ),
          name: mediaService.getFileNameFromHeaders(pdfResponse.headers, 'report.pdf')
        })
      } catch (e) {
        showAlertError(e)
      } finally {
        this.$store.commit('FINISH_IS_SENDING_REQUEST_MODAL')
      }
    },
    async onSubmit (data) {
      await this.createFiles(data)
      this.isFilePreview = true
      await this.closeModalPrint()
    },

    async closeModalPrint () {
      this.isPressedBtnOk = false
      this.isCommentEnabled = false
      await this.closeModal()
    },

    onClickBtnOk () {
      this.isPressedBtnOk = true
    }
  }
}
</script>
